/**
 * Uloženie z CRM panelu + reload detailu (parita ServiceTaskDetail: setDialogText / setVisible v detaile).
 * @param {((saveFn?: () => void|Promise<void>) => void|Promise<void>)|undefined} onChanged
 * @param {() => void|Promise<void>} saveFn
 */
export async function runCrmPanelMutation(onChanged, saveFn) {
  const executeSave = async () => {
    if (typeof saveFn === 'function') {
      return await saveFn();
    }
    return null;
  };
  if (typeof onChanged !== 'function') {
    return await executeSave();
  }
  return await onChanged(executeSave);
}

/** Parita ServiceTaskDetail – modrý info toast namiesto zeleného CRM success. */
export function showCrmWorkflowToast(toast, t, detailKey, life = 3000) {
  toast?.current?.show({
    severity: 'info',
    summary: t('ServiceTask.Confirmed'),
    detail: t(detailKey),
    life,
  });
}
